<template>
  <layout-default>
    <template v-slot:toolbar> </template>
    <div class="page-notifications-grouped">
      <v-overlay :value="loading" z-index="4">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div class="page-notifications-grouped-wrapper">
        <v-tabs
          class="page-notifications-grouped-tabs"
          v-model="tab"
          fixed-tabs
          @change="loadNotifications"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab :disabled="additionalTab === 1">All time</v-tab>
          <v-tab :disabled="additionalTab === 1">3 days</v-tab>
          <v-tab :disabled="additionalTab === 1">Last 24h</v-tab>
        </v-tabs>
        <v-tabs
          class="page-notifications-grouped-tabs"
          v-model="additionalTab"
          fixed-tabs
          @change="loadNotifications"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab>All</v-tab>
          <v-tab>Unread</v-tab>
        </v-tabs>
        <v-btn
          text
          elevation="0"
          color="accent"
          class="readall"
          :disabled="unreadNotificationsGrouped === 0"
          @click="readAllGrouped"
          ><v-icon>bhi-double-check</v-icon> Mark all as read</v-btn
        >
        <v-tabs-items
          class="page-notifications-grouped-v-tabs-items"
          v-model="tab"
          v-for="notification in notifications.content"
          :key="notification.profile.profileId"
        >
          <div class="page-notifications-grouped-card-container">
            <notification
              :key="notification.profile.profileId"
              :notification="notification"
              :expand="isAdvisor"
              :tab="tab"
            />
          </div>
        </v-tabs-items>
        <div
          class="page-notifications-grouped--empty"
          v-if="notifications.content.length === 0"
        >
          <span class="icon">
            <img src="@/assets/empty-notification-bell.png" />
          </span>
          <h3 class="page-notifications-grouped--empty-title">
            You don't have any notifications that match your filters
          </h3>
        </div>
      </div>
    </div>
  </layout-default>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import LayoutDefault from '@/layouts/LayoutDefault.vue'
import Notification from '@/components/notifications/Notification.vue'

export default {
  name: 'Library',
  components: {
    LayoutDefault,
    Notification,
  },
  data() {
    return {
      loading: false,
      tab: null,
      additionalTab: null,
    }
  },
  computed: {
    ...mapState('userStates', [
      'notifications',
      'profileId',
      'notificationsGroupedFirstRender',
    ]),
    ...mapState('dictionariesStates', ['dictionaryPracticeUserRole']),
    ...mapGetters('userStates', ['getRolename']),
    isAdvisor() {
      return (
        this.dictionaryPracticeUserRole[this.getRolename] ===
        this.dictionaryPracticeUserRole.Advisor
      )
    },
    unreadNotificationsGrouped() {
      if (this.notifications && this.notifications.content) {
        const allUnreadNotificationsGrouped = this.notifications.content.reduce(
          (acc, notification) => {
            if (notification.countUnread === undefined) {
              return 0
            }
            return acc + notification.countUnread
          },
          0,
        )
        return allUnreadNotificationsGrouped
      }
      return 0
    },
    notificationsGrouped() {
      return this.notificationsGroupedFirstRender
    },
  },
  watch: {
    async additionalTab() {
      if (this.additionalTab === 1) {
        const defaultQueryParams = new URLSearchParams()
        defaultQueryParams.append('filter', 'all')
        const response = await this.getNotificationsGrouped(defaultQueryParams)

        const content = response.content
        const participantNotifications = content.filter(el => {
          return el.countUnread > 0 ? el : null
        })
        const participantProfiles = participantNotifications.map(
          el => el.profile,
        )
        this.$store.commit(
          'profilePreviewsStates/setProfilePreviews',
          participantProfiles,
          {
            root: true,
          },
        )
        this.$store.commit('userStates/updateNotifications', {
          content: participantNotifications,
        })
        this.tab = 0
      }
    },
  },
  methods: {
    ...mapActions('userStates', [
      'getNotificationsGrouped',
      'readNotification',
      'readNotificationsAll',
      'getNotifications',
    ]),

    readAllGrouped() {
      this.additionalTab = 0
      this.readNotificationsAll({ isAdvisor: this.isAdvisor })
    },
    loadNotifications() {
      const content = this.notificationsGrouped.content
      const defaultQueryParams = new URLSearchParams()
      defaultQueryParams.append('filter', this.tab === 1 ? '3d' : '1d')

      if (this.tab !== 0) {
        return this.getNotificationsGrouped(defaultQueryParams)
      }
      if (this.additionalTab === 0 && this.tab === 0) {
        this.$store.commit('userStates/updateNotifications', {
          content,
        })
        const participantProfiles = content.map(el => el.profile)
        this.$store.commit(
          'profilePreviewsStates/setProfilePreviews',
          participantProfiles,
          {
            root: true,
          },
        )
      } else if (this.additionalTab === 1) {
        const participantNotifications = content.filter(el => {
          return el.countUnread > 0 ? el : null
        })
        const participantProfiles = participantNotifications.map(
          el => el.profile,
        )
        this.$store.commit(
          'profilePreviewsStates/setProfilePreviews',
          participantProfiles,
          {
            root: true,
          },
        )
        this.$store.commit('userStates/updateNotifications', {
          content: participantNotifications,
        })
      } else {
        return null
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.page-notifications-grouped {
  background: #f4f4f4;
  padding: 16px 2 * $gutter 0;
  height: 100%;

  &-heading {
    color: $bh-gray--2;
    font-size: 1rem;
    padding-left: 8px;
  }
  &-wrapper {
    width: 500px;
    margin: 0 auto;

    .readall {
      min-height: 48px;
      width: 100%;
      text-align: center;
      font-size: 16px !important;
      line-height: 20px;
      font-weight: 700;
      color: $bh-blue;
      border-radius: 58px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      background-color: $bh-new-gray;
      margin-bottom: 12px;
      padding: 12px 24px 12px 12px;

      .v-icon {
        margin-right: 8px;

        &.v-icon {
          font-size: 18px;
        }
      }
    }
  }

  &-v-tabs-items {
    .v-window__container {
      position: initial;
    }

    .shadow {
      position: absolute;
      width: calc(100% - 32px);
      height: 56px;
      bottom: -12px;
      border-radius: 8px;
      background-color: rgba(255, 255, 255, 0.8);
      box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.08);
      z-index: 1;
      left: 16px;

      &--bottom {
        bottom: -20px;
        width: calc(100% - 54px);
        left: 28px;
        z-index: 0;
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }
  .page-notifications-grouped-card-container {
    z-index: 2;
    .notification {
      margin: 0;
    }
    .v-tabs__markAsRead {
      color: $bh-blue;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 2px;
      text-transform: uppercase;
      border-radius: 0%;
    }

    .v-tabs__showLess {
      color: $bh-gray--2;
      font-size: 12px;
      font-weight: 700;
      width: 100%;
      border-radius: 0%;
    }
  }
}
.v-card__title {
  word-break: normal;
}
</style>
